/**
*
* RedCalendar
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import formatDate from 'helpers/formatDate';

import fetchPublicData from 'helpers/fetchPublicData';
import setLanguageContent from 'helpers/setLanguageContent';

import Loader from 'components/Loader';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import {
  sortByDate
} from './helpers';


import CalendarsPlaceholder from './styles/CalendarsPlaceholder';

import defaultTextValues from './defaultTextValues';

class RedCalendar extends React.PureComponent {
  constructor() {
    super();

    this._isMounted = false;

    this.getCalendarsList = this.getCalendarsList.bind(this);


    this.state = {
      calendarsLoader: '',
      calendarsList: ''
    };

  }

  async getCalendarsList() {

    const {
      commonData,
    } = this.props;

    const {
      organizationId,
      componentPayload
    } = commonData;

    const {
      calendarId
    } = componentPayload;

    if (this._isMounted) this.setState({
      calendarsLoader: <Loader />
    });


    if (organizationId && calendarId) {
      const getCalendar = await fetchPublicData({
        payload: {
          organizationId: organizationId,
          calendarId: calendarId
        },
        url: 'ajaxGetOrganizationCalendarBasicInfoPublic',
        upload: true
      });

      if (getCalendar && getCalendar.status === 'success' && getCalendar.data) {
        if (this._isMounted) return this.setState({
          calendarsList: getCalendar.data,
          calendarsLoader: ''
        });
      } else {
        if (this._isMounted) return this.setState({
          calendarsLoader: ''
        });
      }
    }
  }

  componentDidMount() {

    this._isMounted = true;
    if (this.props.commonData.componentPayload.calendarId) {
      this.getCalendarsList();
    }    
  }

  componentDidUpdate(prevProp) {
    const {
      commonData,
    } = this.props;

    const {
      componentPayload
    } = commonData;

    const {
      calendarId
    } = componentPayload;

    if (prevProp.commonData.componentPayload.calendarId !== calendarId) {
      this.getCalendarsList();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      language
    } = this.props;

    const {
      isEditor
    } = commonProps;

    const {
      calendarsList,
      calendarsLoader
    } = this.state;

    const calendarsListSorted = calendarsList ? calendarsList.sort(sortByDate) : '';


    let calendarTiles = calendarsListSorted ? calendarsList.map((event, i) => {

      const thisEvent = event && event.slug ? event : isEditor ? {
        title: {
          en: 'Not published event... This is only placeholder for editing.'
        }
      } : '';

      if (!thisEvent) return;

      const elementKey = isEditor ? 'EvenCalendarTile-' + i : 'EvenCalendarTile-' + event.slug;

      const dateToValue = formatDate(thisEvent.dateFrom, thisEvent.dateTo, thisEvent.timezone);

      const isOdd = i % 2 === 0;
      return (
        <Wrapper
          {...commonProps}
          
          key={elementKey}
          typeOfStyle={isOdd ? 'evenCalendarTile' : 'oddCalendarTile'}
          editorData={
              {
                editorType: isOdd ? 'evenCalendarTile' : 'oddCalendarTile',
                ...commonData
              }
            }
        >  
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'eventDate'}
            editorData={
                {
                  editorType: 'eventDate',
                  ...commonData
                }
              }
          >
            {dateToValue}
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'eventTitle'}
            editorData={
                {
                  editorType: 'eventTitle',
                  ...commonData
                }
              }
          >
            {setLanguageContent(thisEvent, 'title', language)} 
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'horizontalDivider'}
            editorData={
                {
                  editorType: 'horizontalDivider',
                  ...commonData
                }
              }
          />
          <Wrapper
            {...commonProps}
            
            type={'text'}
            typeOfStyle={'eventButton'}
            href={event.isChapter ? `http://${thisEvent.domain}/${event.useChapterSlug ? 'chapter' : 'location' }/${event.slug}` : `http://${thisEvent.domain}`}
            target={'_blank'}
            editorData={
                {
                  editorType: 'eventButton',
                  ...commonData
                }
              }
          />
        </Wrapper>
        );
      }) : '';

    if (!calendarsList && isEditor) calendarTiles = (
      <CalendarsPlaceholder>
        <span>
          {'Choose Calendar inside Section settings.'}
        </span>
      </CalendarsPlaceholder>
    );

    return (
      <Wrapper
        {...commonProps}
        

        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >

        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'sectionTitle'}
            defaultValues={defaultTextValues}
            type={'text'}
            editorData={
              {
                editorType: 'sectionTitle',
                ...commonData
              }
            }
          />
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'paragraph'}
            type={'text'}
            editorData={
              {
                editorType: 'paragraph',
                ...commonData
              }
            }
          />
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'calendarWrapper'}
            editorData={
              {
                editorType: 'calendarWrapper',
                ...commonData
              }
            }
          >
           {calendarsLoader ?  calendarsLoader : calendarTiles}
          </Wrapper>
          
        </Wrapper>
      </Wrapper>
    );
  }


}

RedCalendar.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  language: PropTypes.string
};

export default RedCalendar;


